import React from 'react';
import PropTypes from 'prop-types';
import common from 'constants/common';
import { format } from 'date-fns';

const EditRowMenu = ({ onEdit, onDelete, lastEdited, isFirstRow }) => (
  <div
    className={`${
      isFirstRow ? 'editable-row__menu-first-row' : 'editable-row__menu'
    }`}
  >
    {onDelete && (
      <div className="editable-row__menu-item-delete" onClick={onDelete}>
        Delete
      </div>
    )}
    {onEdit && (
      <div className="editable-row__menu-item-edit" onClick={onEdit}>
        Edit tab
      </div>
    )}

    <div className="editable-row__menu-item-author">
      <div>Last edited by {lastEdited.author}</div>
      {lastEdited?.date && (
        <div>
          {format(new Date(lastEdited.date), common.dateFormats.dateAndTime)}
        </div>
      )}
    </div>
  </div>
);

EditRowMenu.propTypes = {
  lastEdited: PropTypes.shape().isRequired,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  isFirstRow: PropTypes.bool,
};

export default EditRowMenu;
